import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { CTAButton } from './CTAButton';
export function Testimonials() {
  return <section className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-243" data-mp="3fzntdk80p90u">
      <div className="mx-auto max-w-3xl" data-id="element-244" data-mp="3fxkv6cwpo9l1">
        <h2 className="text-center font-display text-2xl font-700 uppercase leading-tight text-white sm:text-3xl" data-id="element-245" data-mp="3b147tkxc5z90">
          What dentists should be able to say after using the system
        </h2>

        <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-246" data-mp="31zd1cduz1oe3">
          {testimonials.map(item => <li key={item.name} className="flex flex-col rounded-2xl border border-white/10 bg-navy-950 p-5" data-id="element-247" data-mp="2x09x2vmtfm76">
              <QuoteIcon className="h-6 w-6 shrink-0 text-gold-500" aria-hidden="true" strokeWidth={1.5} data-id="element-248" data-mp="2s3jk4h6b56pz" />
              <p className="mt-3 text-sm leading-relaxed text-slate-100 sm:text-base" data-id="element-249" data-mp="qbeq9058zzcm">
                “{item.quote}”
              </p>
              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-250" data-mp="h8197snheoml">
                <img src={item.image} alt={item.name} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} loading="lazy" data-id="element-251" data-mp="m5sx8bl09qli" />
                <div data-id="element-252" data-mp="zw64sctzj3ab">
                  <p className="text-sm font-700 leading-tight text-white" data-id="element-253" data-mp="zxqzq3k7oo8p">{item.name}</p>
                  <p className="text-xs leading-tight text-gold-400" data-id="element-254" data-mp="14uhfsqw0nju4">{item.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 text-center text-xs leading-relaxed text-slate-400" data-id="element-255" data-mp="v5g0l2xap6h7">
          Note: Replace these placeholder statements with verified customer testimonials once
          available.
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-256" data-mp="1nmk14fjlroap">
          <CTAButton label="Start using the system today" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-257" data-mp="1nnbjups3prjk" />
        </div>
      </div>
    </section>;
}